"use strict";

export function initInScope ($scope) {

    let discountItem = $scope.find('.js-discount-item__item');
    let discountBtnIcon = $scope.find('.js-discount-item__icon');

    $scope.find('.js-discount-item__btn').on('click', function (e) {
        discountItem.toggleClass('d-none');
        discountBtnIcon.toggleClass('icon-rotate-180');
    });
}
